import { Accordion, AccordionItem } from "@heroui/accordion";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import { useSearchFilter } from "../../../../../../utils/functions/useDate";
import {
  useGetAllPIPQuery,
  useGetMainSelfReviewQuery,
} from "../../../../../api/employeeApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { CTAButtons } from "../../../../../global/components/Buttons/buttons";
import bull from "../../../../assets/bull.png";
import flag from "../../../../assets/finish-FLAG.png";
import person from "../../../../assets/personAppraisal.png";
import {
  default as PageLayout,
  default as PageStyle,
} from "../../../../Components/Layout/PageLayout";
import { TableActions } from "../../../../Components/Misc/Actions";
import { AppModalTemplate } from "../../../../Components/Modals/Modals";
import Pagination from "../../../../Components/Pagination/Pagination";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../../Components/Search/Search";
import Table from "../../../../Components/Table/Table";
import { MetaData } from "../../../Employee/SelfAppraisal/data";
import { getStatusText } from "../../../Finance/CostCenter/Class";
import { MeasurementTypeFormatter } from "../Modals/data";
import { PIPModal } from "../Modals/PIPModal";
import { FilterByStatus } from "../status";

export const ViewPIP = () => {
  const { id } = useParams();
  const { data } = useGetMainSelfReviewQuery(id);
  const allObjectives = data?.responseObject?.objectives || [];
  const employeeData = data?.responseObject?.employee;
  const navigation = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [kraId, setKraId] = useState(null);
  const handleModal = () => {
    setOpenModal(!openModal);
  };

  const onValidate = () => {
    setOpenModal(false);
  };

  const {
    searchText,
    filter,
    setSearchText,
    setFilter,
    date,
    setDate,
    // findSearch,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const {
    data: pip,
    isLoading: loadPIP,
    error,
  } = useGetAllPIPQuery({
    AppraiseeId: employeeData?.id,
    GeneralSearch: searchText,
    PageSize: pageSize,
    PageNumber: currentPage,
    ApprovalStatus: filter,
  });

  const actionButton = (
    <CTAButtons onClick={handleModal}>Create PIP</CTAButtons>
  );
  const handleView = (id) => {
    if (id) {
      navigation(`${id}/view-pip`);
    }
  };
  return (
    <PageLayout title={"PIP Details"} hasBack={true}>
      <div className={DashboardStyle.app_view_controls}></div>
      <div>
        <div className={DashboardStyle.view_app_components}>
          <div className="mb-4"></div>
          <Accordion
            aria-label={`Accordion 1`}
            selectionMode="single"
            defaultExpandedKeys={["1"]}
            titleWrapper="shadow-md rounded-md border border-gray-200"
          >
            <AccordionItem
              title={
                <div className="flex items-center gap-5 px-5">
                  <img src={person} alt="" />{" "}
                  <span className="text-[#305F32] font-[600]">
                    EMPLOYEE PROFILE SUMMARY
                  </span>
                </div>
              }
              className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
            >
              <MetaData referenceId={id} data={employeeData} />
            </AccordionItem>
          </Accordion>
          {allObjectives
            ?.filter((item) =>
              item.krAs.every(
                (kra) =>
                  kra.employeeReviewDetails?.filter(
                    (item) => item.appraisalType === 1
                  )?.[0]?.kraScore < kra.threshold
              )
            )
            ?.map((item, index) => (
              <Accordion
                aria-label={`Accordion ${index + 1}`}
                key={index + 1}
                selectionMode="single"
                titleWrapper="shadow-md rounded-md border border-gray-200"
              >
                <AccordionItem
                  key={index + 1}
                  title={
                    <div className="flex items-center justify-between px-5">
                      <div className="flex items-center gap-5">
                        <img src={flag} alt="" />
                        <span className="text-[#4B664C] font-[600]">
                          OBJECTIVE: {item?.objectiveTitle}
                        </span>
                      </div>
                      <div>
                        <span className="text-[#4B664C] font-[600]">
                          Weight: {item?.objectiveWeight}%
                        </span>
                      </div>
                      <div className="w-10" />
                    </div>
                  }
                  className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                >
                  <div>
                    {item?.krAs
                      .filter(
                        (kra) =>
                          kra.employeeReviewDetails?.filter(
                            (item) => item.appraisalType === 1
                          )?.[0]?.kraScore < kra.threshold
                      )
                      ?.map((items, kraIndex) => (
                        <Accordion
                          key={kraIndex + 1}
                          aria-label={`Accordion ${kraIndex + 1}`}
                          selectionMode="single"
                          defaultExpandedKeys={["1"]}
                          titleWrapper="shadow-md rounded-md border border-gray-200"
                          onClick={() => setKraId(items.kraId)}
                        >
                          <AccordionItem
                            key={kraIndex + 1}
                            title={
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-5 px-5">
                                  <img src={bull} alt="" />
                                  <span className="text-[#4B664C] font-[600]">
                                    KRA: {items?.kraTitle}
                                  </span>
                                </div>
                                {/* <h4 className="text-[#00AB09] font-[500]">
                              Score: {items.kraScore || "N/A"}
                            </h4> */}
                              </div>
                            }
                            className="shadow-md rounded-md border border-gray-200 py-3 mb-2"
                          >
                            <div>
                              {items.isAutoGenerated && (
                                <div className="flex items-center justify-between px-5">
                                  <div />
                                  <div>
                                    <p className="text-[#4B664C] font-[600]">
                                      isAutogenerated
                                    </p>
                                  </div>
                                </div>
                              )}
                              <div
                                key={kraIndex + 1}
                                className="flex items-center gap-5 py-2 px-5"
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "180px 1fr",
                                  alignItems: "center",
                                  gap: "16px",
                                }}
                              >
                                <h2 className="text-[#305F32] font-[600]">
                                  Title: {items.kraTitle}
                                </h2>
                                <h4 className="text-[#305F32] font-[500]">
                                  Description: {items.kraDescription}
                                </h4>
                                <h2 className="text-[#305F32] font-[600]">
                                  Target: {items.targetValue}
                                </h2>
                                <h4 className="text-[#00AB09] font-[500]">
                                  Score:{" "}
                                  {items?.employeeReviewDetails?.filter(
                                    (item) => item.appraisalType === 1
                                  )?.[0]?.kraScore || "N/A"}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  Measurement Type:{" "}
                                  {MeasurementTypeFormatter(
                                    items.measurementType
                                  )}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  Is Autogenerated:{" "}
                                  {items.isAutoGenerated ? "Yes" : "No"}
                                </h4>
                                {items.isAutoGenerated && (
                                  <h4 className="text-[#305F32] font-[500]">
                                    Source: {items.source}
                                  </h4>
                                )}
                                <h4 className="text-[#305F32] font-[500]">
                                  KRA Type:{" "}
                                  {items.kraType === 1 ? "Core" : "None Core"}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  Include Self Review:{" "}
                                  {items.includeSelfReview ? "Yes" : "No"}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  Period Start Date:{" "}
                                  {new Date(
                                    items.periodStartDate
                                  ).toLocaleDateString()}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  Period End Date:{" "}
                                  {new Date(
                                    items.periodEndDate
                                  ).toLocaleDateString()}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  Next Due Date:{" "}
                                  {new Date(
                                    items.nextDueDate
                                  ).toLocaleDateString()}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  SLA Due Date:{" "}
                                  {new Date(
                                    items.slaDueDate
                                  ).toLocaleDateString()}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  SLA Reminder Count: {items.slaReminderCount}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  SLA Start Duration: {items.slaStartDuration}
                                </h4>
                                <h4 className="text-[#305F32] font-[500]">
                                  Threshold: {items.threshold}
                                </h4>
                              </div>
                              <div
                                style={{ marginTop: "1rem", paddingRight: 20 }}
                                className={DashboardStyle.button_cage}
                              >
                                {actionButton}
                              </div>
                            </div>
                          </AccordionItem>
                        </Accordion>
                      ))}
                  </div>
                </AccordionItem>
              </Accordion>
            ))}
        </div>
      </div>
      <PageStyle hasBack={false} demoTitle={null} hasTopPageDemo>
        <form className={DashboardStyle.dashboard_filter}>
          <SearchFilter
            value={searchText}
            text={(searchText) => setSearchText(searchText)}
          />
          <CalendarFilter2
            name="Select Date Range"
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            normalDate
          />
          <ProDropFilter
            filter={filter}
            setFilter={setFilter}
            name={"Status"}
            filterBy={FilterByStatus}
          />
        </form>
        <div className={DashboardStyle.dashboard_table_holder}>
          <Table>
            <thead>
              <tr>
                <th>S/N</th>
                <th>PIP Objective</th>
                {/* <th>Expected Improvement</th>
                <th>Development Plan</th> */}
                <th>Target Improvement Percent</th>
                <th>Engagement Hours</th>
                <th>Appraisee Comment</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Approval Status</th>
                <th>Initiated Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loadPIP && (
                <tr>
                  <td colSpan={10} className="text-center">
                    Loading...
                  </td>
                </tr>
              )}
              {pip?.result?.map((kra, index) => (
                <tr key={kra?.id || index}>
                  <td>{index + 1}</td>
                  <td>{kra?.pipObjective}</td>
                  {/* <td>{kra?.expectedImprovement}</td>
                  <td>{kra?.developmentPlan}</td> */}
                  <td>{kra?.targetImprovementPercent}</td>
                  <td>{kra?.engagementHours}</td>
                  <td>{kra?.appraiseeComment}</td>
                  <td>{FormatDateTime(kra?.startDate, "DD/MM/YYYY")}</td>
                  <td>{FormatDateTime(kra?.endDate, "DD/MM/YYYY")}</td>
                  <td>
                    {typeof kra?.approvalStatus === "number"
                      ? getStatusText(kra?.approvalStatus)
                      : kra?.approvalStatus}
                  </td>
                  <td>{FormatDateTime(kra.createdDate, "DD/MM/YYYY")}</td>
                  <td>
                    <TableActions hasChildren={true} url={`${kra.id}/view-pip`}>
                      {[
                        {
                          name: "View Details",
                          action: () => handleView(kra?.id),
                        },
                      ]}
                    </TableActions>
                  </td>
                </tr>
              ))}
              {pip?.result?.length === 0 && error && (
                <tr>
                  <td colSpan={10} className="text-center">
                    No PIP for this Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <Pagination
          last_page={data?.responseObject?.previousPage}
          present_page={data?.responseObject?.currentPage}
          totalRows={data?.responseObject?.totalCount}
          pageSize={data?.responseObject?.pageSize}
          // setPageSize={(page) => setPageSize(page)}
          // click={(page) => setCurrentPage(page)}
        />
      </PageStyle>

      {openModal && (
        <AppModalTemplate
          width={"600px"}
          isOpen={openModal}
          setIsOpen={handleModal}
        >
          <PIPModal
            onValidate={onValidate}
            isOpen={openModal}
            setIsOpen={setOpenModal}
            referenceId={id}
            appraiseeId={employeeData.id}
            kraId={kraId}
          />
        </AppModalTemplate>
      )}
    </PageLayout>
  );
};
